import React, { Component } from "react";

export default class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIdx: 1, // current slide
      transitionTime: props.transition,
      dragStart: 0,
      dragStartTime: new Date(),
      lastIdx: 1,
      slideWidth: undefined,
      slideHeight: undefined,
      //a 'preview' carousel centers 1 item and displays half an item on both sides - effectively previewing the next slide
      //if the carousel is a 'preview' carousel, items must be set to 2
      items: props.preview ? 2 : props.items,
      activeBreakpoint: 0,
    };

    this.getItems = this.getItems.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.handleDragMove = this.handleDragMove.bind(this);
    this.handleDragStart = this.handleDragStart.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.handleSwap = this.handleSwap.bind(this);
    this.getActiveBreakpoint = this.getActiveBreakpoint.bind(this);
    this.carouselRef = React.createRef();
    this.slidesRef = React.createRef();
  }

  componentDidMount() {
    const component = this;

    window.addEventListener("resize", function (e) {
      component.handleResize(window.outerWidth);
    });

    if (component.props.resizeOnLoad) {
      window.addEventListener("load", function (e) {
        component.handleResize(window.outerWidth);
      });
    }
    // console.log('Did Mount', this.slidesRef.current && !this.state.slideHeight);
    if (this.slidesRef.current && !this.state.slideHeight) {
      this.setState({
        slideHeight: this.props.height
          ? this.props.height
          : this.slidesRef.current.offsetHeight,
        items: this.getItems(window.outerWidth),
        activeBreakpoint: this.getActiveBreakpoint(window.outerWidth)
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", window);
  }

  componentDidUpdate(prevProps) {
    // console.log('Did Update', this.slidesRef.current &&
    // (this.state.slideHeight === undefined ||
    //   prevProps.responsive !== this.props.responsive ||
    //   prevProps.items !== this.props.items ||
    //   this.slidesRef.current.offsetHeight > this.state.slideHeight ||
    //   (prevProps.children === undefined && this.props.children)), this.getItems(window.outerWidth));
    if (
      this.slidesRef.current &&
      (this.state.slideHeight === undefined ||
        prevProps.responsive !== this.props.responsive ||
        prevProps.items !== this.props.items ||
        this.slidesRef.current.offsetHeight > this.state.slideHeight ||
        (prevProps.children === undefined && this.props.children))
    ) {
      this.setState({
        slideHeight: this.props.height
          ? this.props.height
          : this.slidesRef.current.offsetHeight,
        items: this.getItems(window.outerWidth),
        activeBreakpoint: this.getActiveBreakpoint(window.outerWidth)
      });
    }
  }

  getDragX(event, isTouch) {
    return isTouch ? event.touches[0].pageX : event.pageX;
  }

  getActiveBreakpoint(width) {
    const { responsive } = this.props;
    let activeBreakpoint = 0;

    if (responsive) {
      const breakpoints = Object.keys(responsive).map((key) => parseInt(key));
      breakpoints.sort((a, b) => (a > b ? 1 : -1));
      activeBreakpoint = breakpoints[0];

      breakpoints.forEach((breakpoint) => {
        if (width > breakpoint && breakpoint > activeBreakpoint) {
          activeBreakpoint = breakpoint;
        }
      });
    }

    return activeBreakpoint;
  }

  getItems(width) {
    const { responsive } = this.props;
    const items = this.props.items;
    const activeBreakpoint = this.getActiveBreakpoint(width);

    // default responsive behavior
    if (
      Object.keys(responsive).length === 1 &&
      Object.keys(responsive)[0] === "0"
    ) {
      return width > 768 ? items : 1;
    } else {
      return responsive[activeBreakpoint].items;
    }
  }

  handleDragStart(event, isTouch) {
    const x = this.getDragX(event, isTouch);
    this.setState({
      dragStart: x,
      dragStartTime: new Date(),
      slideWidth: this.carouselRef.current.offsetWidth,
    });
  }

  handleDragMove(event, isTouch) {
    const { dragStart, lastIdx, currentIdx, slideWidth } = this.state;

    const x = this.getDragX(event, isTouch);
    const offset = dragStart - x;
    const percentageOffset = offset / slideWidth;
    const newIdx = lastIdx + percentageOffset;
    const SCROLL_OFFSET_TO_STOP_SCROLL = 30;

    // Stop scrolling if you slide more than 30 pixels
    if (Math.abs(offset) > SCROLL_OFFSET_TO_STOP_SCROLL) {
      event.stopPropagation();
    }

    this.setState({
      currentIdx: newIdx,
    });
  }

  handleDragEnd() {
    const { transition } = this.props;
    const { dragStartTime, currentIdx, lastIdx } = this.state;

    const timeElapsed = new Date().getTime() - dragStartTime.getTime();
    const offset = lastIdx - currentIdx;
    const velocity = Math.round((offset / timeElapsed) * 10000);

    let newIdx = Math.round(currentIdx);

    if (Math.abs(velocity) > 5) {
      newIdx = velocity < 0 ? lastIdx + 1 : lastIdx - 1;
    }

    this.setState({
      dragStart: 0,
      currentIdx: newIdx,
      lastIdx: newIdx,
      transitionTime: transition,
    });
  }

  handleDotClick(idx) {
    const { transition } = this.props;
    this.setState({
      currentIdx: idx + 1,
      transitionTime: transition,
    });
  }

  handleNext() {
    const { children, transition, preview } = this.props;
    const { currentIdx, items } = this.state;

    if (
      children.length % items !== 0 &&
      currentIdx === (children.length - (children.length % items)) / items + 1 &&
      !preview
    ) {
      const newIdx = this.state.currentIdx + (children.length % items) / items;
      this.setState({
        currentIdx: newIdx,
        lastIdx: newIdx,
        transitionTime: transition,
      });
    } else if (currentIdx !== children.length / items + 1 || preview) {
      //preview calculations require always adding one and not a fraction to the current index when moving to the next slide
      this.setState({
        currentIdx: this.state.currentIdx + 1,
        lastIdx: this.state.currentIdx + 1,
        transitionTime: transition,
      });
    }
  }

  handlePrev() {
    const { transition } = this.props;
    const { currentIdx } = this.state;

    if (currentIdx % 1 !== 0) {
      this.setState({
        currentIdx: this.state.currentIdx - (currentIdx % 1),
        lastIdx: this.state.currentIdx - (currentIdx % 1),
        transitionTime: transition,
      });
    } else if (currentIdx !== 0) {
      this.setState({
        currentIdx: this.state.currentIdx - 1,
        lastIdx: this.state.currentIdx - 1,
        transitionTime: transition,
      });
    }
  }

  handleResize(width) {
    this.setState({
      items: this.getItems(width),
    });
    return;
  }

  handleSwap() {
    const { children, preview } = this.props;
    const { currentIdx, items } = this.state;
    if (
      !preview &&
      (currentIdx === 0 || currentIdx >= children.length / items + 1)
    ) {
      this.setState({
        currentIdx: currentIdx === 0 ? children.length / items : 1,
        lastIdx: currentIdx === 0 ? children.length / items : 1,
        transitionTime: "0ms",
      }); 
    }
    //preview calculations require dealing in whole numbers and not fractions
    if (preview && (currentIdx === 0 || currentIdx > children.length)) {
      this.setState({
        currentIdx: currentIdx === 0 ? children.length : 1,
        lastIdx: currentIdx === 0 ? children.length : 1,
        transitionTime: "0ms",
      });
    }
  }

  render() {
    const {
      currentIdx,
      transitionTime,
      slideHeight,
      items,
      activeBreakpoint,
    } = this.state;
    const {
      arrowStyles,
      children,
      nav,
      navOverlay,
      height,
      margin,
      thumbs,
      className,
      responsive,
    } = this.props;
    let { dots, dotsOverlay, dotType, preview } = this.props;

    if (thumbs.length > 0) {
      dots = true;
      dotsOverlay = false;
      dotType = "thumb";
    }

    const slideStyle = {
      paddingRight: margin || "initial",
      overflow: "hidden",
      width: "100%",
    };

    const wrapperStyle = {
      height: slideHeight ? slideHeight : "auto",
    };

    if (this.props.minHeight) {
      wrapperStyle.minHeight = this.props.minHeight;
    }

    //the following series of variables account for the offsets for centering when props 'preview' is present
    const scale = preview && responsive[activeBreakpoint].items > 1 ? 50 : 100;
    const currentItem = preview && responsive[activeBreakpoint].items > 1 ? Math.ceil(currentIdx) : currentIdx;
    const offset = preview && responsive[activeBreakpoint].items > 1 ? 25 : 0;
    const marginOffset = margin ? preview && responsive[activeBreakpoint].items > 1 ? Math.ceil(currentIdx) * (margin/2) : currentIdx * margin : 0;
    //left is used below for positioning of the slides container
    const left = `calc(-${scale * currentItem + offset}% - ${marginOffset}px)`;

    return !children || children.length === 0 ? (
      <div className="carousel__wrapper">
        {this.props.noResultsText || "No items to display"}
      </div>
    ) : children.length > items ? (
      <div className={`carousel ${className}`} ref={this.carouselRef}>
        <div className="carousel__wrapper" style={wrapperStyle}>
          <div
            className="carousel__slides"
            ref={this.slidesRef}
            onTransitionEnd={() => this.handleSwap()}
            onTouchStart={(event) => this.handleDragStart(event, true)}
            onTouchMove={(event) => this.handleDragMove(event, true)}
            onTouchEnd={() => this.handleDragEnd(true)}
            style={{
              left,
              width: `calc(${
                (100 / items) * (children.length + items * 2)
              }% + ${margin ? (children.length / items + 2) * margin : 0}px)`,
              transition: `left ${transitionTime} 0ms`,
              height: height || "initial",
            }}
          >
            {React.Children.map(children.slice(-items), (child, idx) => (
              <div
                className="carousel__slide"
                style={slideStyle}
                key={idx - items}
              >
                {child}
              </div>
            ))}

            {React.Children.map(children, (child, idx) => (
              <div className="carousel__slide" kex={idx} style={slideStyle}>
                {child}
              </div>
            ))}

            {React.Children.map(children.slice(0, items), (child, idx) => (
              <div
                className="carousel__slide"
                style={slideStyle}
                key={idx + children.length}
              >
                {child}
              </div>
            ))}
          </div>
        </div>

        {(dots || thumbs.length > 0) &&
          children &&
          children.length > 0 &&
          items === 1 && (
            <div
              className={`carousel__dots ${
                dotsOverlay ? "carousel__dots--overlay" : ""
              }`}
            >
              {children.map((slide, idx) =>
                dotType === "dot" || !thumbs[idx] ? (
                  <span
                    className={`carousel__dot ${
                      idx === currentIdx - 1 ||
                      idx === currentIdx - React.Children.count(children) - 1 || // psuedo first slide active
                      idx === currentIdx + React.Children.count(children) - 1 // psuedo last slide active
                        ? "carousel__dot--active"
                        : ""
                    }`}
                    key={idx}
                    onClick={() => this.handleDotClick(idx)}
                  />
                ) : (
                  <span
                    className={`carousel__thumb ${
                      idx === currentIdx - 1 ||
                      idx === currentIdx - React.Children.count(children) - 1 || // psuedo first slide active
                      idx === currentIdx + React.Children.count(children) - 1 // psuedo last slide active
                        ? "carousel__thumb--active"
                        : ""
                    }`}
                    key={idx}
                    onClick={() => this.handleDotClick(idx)}
                  >
                    {thumbs[idx]}
                  </span>
                )
              )}
            </div>
          )}

        {nav && (
          <React.Fragment>
            <span
              className={`carousel__arrows carousel__arrows__prev ${
                navOverlay ? "carousel__arrows--overlay" : ""
              } `}
              style={arrowStyles}
              onClick={() => this.handlePrev()}
            ></span>
            <span
              className={`carousel__arrows carousel__arrows__next ${
                navOverlay ? "carousel__arrows--overlay" : ""
              } `}
              style={arrowStyles}
              onClick={() => this.handleNext()}
            ></span>
          </React.Fragment>
        )}
      </div>
    ) : (
      // if there are not enough items do not render slider but return this instead
      <div className="container container--spaced">
        {React.Children.map(children, (child, idx) => (
          <div
            kex={idx}
            className={`grid grid--${(12 / this.props.items)
              .toString()
              .replace(".", "_")}`}
          >
            {child}
          </div>
        ))}
      </div>
    );
  }
}

export function ThumbDot(props) {
  return <div style={{ backgroundImage: `url('${props.d.GiantUrl}')` }}></div>;
}

Carousel.defaultProps = {
  dots: false,
  dotsOverlay: true,
  dotType: "dot", //dot' | 'thumb'
  thumbs: [],
  items: 1,
  responsive: {
    0: {
      items: 1,
    },
  },
  nav: true,
  navOverlay: false,
  transitionType: "slide", //'fade' | 'slide',
  transition: "300ms",
  className: "",
};
